import React from 'react';

import {Link} from 'react-router';

var ListViewContentRight = React.createClass({
  render: function(){
    var date = "";
    if (this.props.value["modified_date"] !== undefined){
      let modifiedDate = this.props.value["modified_date"]
      date = (modifiedDate.getMonth()+1) + "/" + modifiedDate.getDate() + "/" + modifiedDate.getFullYear()
    }
    var slug, accountSlug;
    if(this.props.value != undefined){
       slug = this.props.value["name"].split("/")[1];   // this will set the value of slug so that we can send data in query url to next page(using react router)
       accountSlug = this.props.value["name"].split("/")[0];
    }
    return(
          <div className="theme-list__details theme-list__details--hide">
            {/*
              <ul className="badges__list list-inline">
                <li className="badges__list--item"><img src="images/badge_icon-001.png" alt="badges" title="badges" /></li>
                <li className="badges__list--item"><img src="images/badge_icon-002.png" alt="badges" title="badges" /></li>
                <li className="badges__list--item"><img src="images/badge_icon-003.png" alt="badges" title="badges" /></li>
                <li className="badges__list--item"><img src="images/badge_icon-004.png" alt="badges" title="badges" /></li>
                <li className="badges__list--item"><img src="images/badge_icon-005.png" alt="badges" title="badges" /></li>
              </ul>
            */} 
             {date != "" ?
              <p><strong>Last Modified: {date}</strong></p>  : null }
              <p>{this.props.value["description"] !== "null" ? this.props.value["description"] : ""}<span><Link to = {{pathname: '/details',query: {val:slug, account: accountSlug, lib: this.props.libName}}}>Read more..</Link></span></p>
          </div>
    );
  }
});

export {ListViewContentRight};


/** WEBPACK FOOTER **
 ** ./html/components/ListViewContentRight.jsx
 **/